<template>
	<PopUp
		:title="title"
		:size="size"
		ok-text="Bestätigen"
		:ok-disabled="confirmDisabled"
		:ok-loading="confirmLoading"
		:closable="closable"
		@ok="$emit('confirm')"
		@hidden="$emit('hidden')"
	>
		<slot/>
	</PopUp>
</template>

<script>
import PopUp from "@/vue/common/PopUp"

export default {

	components: {
		PopUp,
	},

	props: {
		title: {
			type: String,
			required: true,
		},
		size: {
			type: String,
			required: false,
		},
		confirmDisabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		confirmLoading: {
			type: Boolean,
			required: false,
			default: false,
		},
		closable: {
			type: Boolean,
			required: false,
			default: true,
		},
	}
}
</script>
